import { useEffect, useRef, useState } from "react";

const counters = [
  { value: 500, suffix: "+", label: "Pisos vaciados" },
  { value: 12, suffix: " años", label: "De experiencia" },
  { value: 100, suffix: "%", label: "Clientes satisfechos" },
  { value: 48, suffix: "h", label: "Respuesta máxima" },
];

function useCountUp(target: number, duration = 1800, active: boolean) {
  const [count, setCount] = useState(0);
  useEffect(() => {
    if (!active) return;
    let start = 0;
    const step = target / (duration / 16);
    const timer = setInterval(() => {
      start += step;
      if (start >= target) {
        setCount(target);
        clearInterval(timer);
      } else {
        setCount(Math.floor(start));
      }
    }, 16);
    return () => clearInterval(timer);
  }, [target, duration, active]);
  return count;
}

function Counter({ value, suffix, label }: { value: number; suffix: string; label: string }) {
  const [active, setActive] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  const count = useCountUp(value, 1800, active);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setActive(true); },
      { threshold: 0.5 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <div ref={ref} className="text-center px-2">
      <div className="text-4xl md:text-5xl lg:text-6xl font-900 text-[#330000] mb-2 break-words" style={{ fontWeight: 900 }}>
        {count}{suffix}
      </div>
      <div className="text-xs md:text-sm font-600 text-[#330000] uppercase tracking-wide leading-tight" style={{ fontWeight: 600 }}>{label}</div>
    </div>
  );
}

export default function TrustCounters() {
  return (
    <section className="py-16 md:py-20 bg-[#FF6666]" style={{ fontFamily: "'Montserrat', sans-serif" }}>
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 divide-x-0 lg:divide-x divide-[#330000]/20">
          {counters.map((c) => (
            <Counter key={c.label} {...c} />
          ))}
        </div>
      </div>
    </section>
  );
}
